// image.service.ts
import { Component, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TvSeasonService {
  
  constructor(private http: HttpClient) {}
  
  getTvSeasonDetails(tv_id:number,season_no:number):Observable<any> {
    const apiUrl = `${environment.backendUrl}/api/tv/${tv_id}/season/${season_no}`;
    return this.http.get<any>(apiUrl);
  }
}